module.exports = __webpack_public_path__ + "static/img/011.62fc9aa7.jpg";